import {
    GuxDropdown,
    GuxFormFieldDropdown,
    GuxListbox,
    GuxOption,
} from "genesys-spark-components-react";
import { useStrings } from "features/i18n/useStrings";
import strings from "./LanguagePicker.strings";
import "./LanguagePicker.less";
import languageList from "strings/languageList.json";

import {
    qualityFormActions,
    selectFormLanguage,
    selectIsFormDisabled,
    selectIsFormPublished,
} from "features/qualityForm/qualityFormSlice";
import { PreviewModeContext } from "features/qualityForm/common/Contexts";
import { loadLocale, Locale } from "i18n";
import { useContext } from "react";
import { useAppDispatch, useAppSelector } from "app/hooks";

export function LanguagePicker() {
    const t = useStrings(strings);
    const { previewMode } = useContext(PreviewModeContext);
    const dispatch = useAppDispatch();
    const formLocale = useAppSelector((state) => selectFormLanguage(state));
    const formPublished = useAppSelector(selectIsFormPublished);
    const formDisabled = useAppSelector(selectIsFormDisabled);
    return (
        <GuxFormFieldDropdown
            className="LanguagePicker"
            data-testid="language-picker"
        >
            <label slot="label">{t.labels.defaultSurveyLanguage}</label>
            <GuxDropdown
                value={formLocale}
                onInput={(e) => {
                    const newLanguage = (e.target as HTMLInputElement)
                        .value as Locale;
                    dispatch(qualityFormActions.setFormLanguage(newLanguage));
                    loadLocale(newLanguage);
                }}
                disabled={previewMode || formPublished || formDisabled}
                aria-disabled={previewMode || formPublished || formDisabled}
            >
                <GuxListbox>
                    {Object.entries(languageList).map(([key, option]) => {
                        return (
                            <GuxOption value={key} key={key}>
                                {option}
                            </GuxOption>
                        );
                    })}
                </GuxListbox>
            </GuxDropdown>
        </GuxFormFieldDropdown>
    );
}
